import { Splide as OriginalSplide } from '@splidejs/splide';

function getFirstNode(nodeList) {
    return [...nodeList].filter((node) => node.tagName === 'LI')[0];
}

function getIndexOfElement(element) {
    return Array.from(element.parentElement.children).indexOf(element);
}

/**
 * Initializes a slider on the given element.
 *
 * You can change the slide to index 3 by sending a custom event:
 * element.dispatchEvent(new CustomEvent('goToSlide', {detail: {control: 3, speed: 400}}));
 * All supported control options: https://splidejs.com/guides/apis/#go
 */
export default class Splide extends OriginalSplide {
    constructor(target, options) {
        const inNeosBackend = window.name === 'neos-content-main';
        if (inNeosBackend) {
            options.clones = 0;
        }
        super(target, options);

        target.addEventListener('goToSlide', (e) => {
            const originalSpeed = this.options.speed;
            this.options.speed = e.detail.speed;
            this.go(e.detail.control);
            this.options.speed = originalSpeed;
        });

        // We are in the backend, so we need to refresh the instance on change
        if (inNeosBackend) {
            this.on('mounted', () => {
                // Update if a slide is added or removed
                const observeTarget = target.querySelector('.splide__list');
                const observer = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        const addedNode = getFirstNode(mutation.addedNodes);
                        const removedNode = getFirstNode(mutation.removedNodes);
                        if (addedNode || removedNode) {
                            console.log('Refreshing instance');
                            this.refresh();
                        }
                        if (addedNode) {
                            // Scroll to the new slide
                            this.go(getIndexOfElement(addedNode));
                        }
                    });
                });
                observer.observe(observeTarget, { childList: true });

                // Go to the slide if it gets selected in the node tree
                document.addEventListener('Neos.NodeSelected', (event) => {
                    const element = event.detail.element;
                    if (!element.classList.contains('splide__slide')) {
                        return;
                    }
                    if (element.closest('.splide__list') !== observeTarget) {
                        return;
                    }
                    this.go(getIndexOfElement(element));
                });
            });
        }
    }
}
